import React from "react";
import PropTypes from "prop-types";

const PatrolCarIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#patrol-car-icon-clip)">
        <path
          d="M12.6673 11.3337H14.0007C14.4007 11.3337 14.6673 11.067 14.6673 10.667V8.66699C14.6673 8.06699 14.2007 7.53366 13.6673 7.40033C12.4673 7.06699 10.6673 6.66699 10.6673 6.66699C10.6673 6.66699 9.80065 5.73366 9.20065 5.13366C8.86732 4.86699 8.46732 4.66699 8.00065 4.66699H3.33398C2.93398 4.66699 2.60065 4.93366 2.40065 5.26699L1.46732 7.20033C1.37904 7.45781 1.33398 7.72813 1.33398 8.00033V10.667C1.33398 11.067 1.60065 11.3337 2.00065 11.3337H3.33398"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33398 11.3333C3.33398 12.0692 3.93143 12.6667 4.66732 12.6667C5.4032 12.6667 6.00065 12.0692 6.00065 11.3333C6.00065 10.5974 5.4032 10 4.66732 10C3.93143 10 3.33398 10.5974 3.33398 11.3333V11.3333"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 11.333H10"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 11.3333C10 12.0692 10.5974 12.6667 11.3333 12.6667C12.0692 12.6667 12.6667 12.0692 12.6667 11.3333C12.6667 10.5974 12.0692 10 11.3333 10C10.5974 10 10 10.5974 10 11.3333V11.3333"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="patrol-car-icon-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

PatrolCarIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PatrolCarIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default PatrolCarIcon;
